/* eslint-disable no-console */
import { ColorType, Level } from './logger.domain';
import { JsonFormatter } from './formatter';
import type { LogRecord } from './logger.domain';
import type { Formatter } from './formatter';

export interface Handler {
  publish(record: LogRecord): void;
}

export class ConsoleHandler implements Handler {

  private formatter: Formatter;

  constructor() {
    this.formatter = new JsonFormatter();
  }

  setFormatter(formatter: Formatter): Handler {
    this.formatter = formatter;
    return this;
  }

  publish(record: LogRecord): void {
    const message = this.formatter.format(record);
    if (record.level === Level.ERROR) {
      console.error(message);
    } else {
      const color = this.getColor(record.level);
      console.log(`%c${message}`, `color: ${color}`);
    }
  }

  /**
   * Returns color by logging level
   *
   * @param logLevel Logging level
   * @returns Color by level
   */
  private getColor(logLevel: Level): ColorType | undefined {
    switch (logLevel) {
      case Level.TRACE:
        return ColorType.BLUE;
      case Level.DEBUG:
        return ColorType.TEAL;
      case Level.INFO:
        return ColorType.GRAY;
      case Level.WARN:
      case Level.ERROR:
        return ColorType.RED;
      case Level.OFF:
      default:
        return undefined;
    }
  }
}
